import React from 'react';
import Select from 'react-select';
import { reactLocalStorage } from 'reactjs-localstorage';
import Const from '../../util/Constants';
import Widget from '../report/Widget';
import DashboardItem from '../report/DashboardItem';
import './Dashboard.css';
import MyDashboard from './MyDashboard';

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.models = reactLocalStorage.getObject(Const.Model);
    const dashboards = this.models.dashboard.options;
    const user = reactLocalStorage.getObject(Const.LoggedInUser);
    const dashboardAccess = user.dashboard;
    const salespersonRaw = this.models.user.options || [];
    const activeUsers = salespersonRaw.filter(u => u.status === 1);
    let visibleUsers;
    if (user.role === 1) {
      visibleUsers = activeUsers;
    } else {
      const childIds = user.child || [];
      visibleUsers = activeUsers.filter(
        u => u.id === user.user_id || childIds.includes(u.id)
      );
    }

    const salespersons = visibleUsers.map(u => ({ label: u.name, value: u.id }));
    const selectedSalesperson =
      salespersons.find(sp => sp.value === user.user_id) || null;

    const systemDashboard = [
      { label: 'My Dashboard (System)', value: 'my_dashboard', type: 'system' },
    ];
    this.options = [...systemDashboard];
    let dashboard = null;

    const filtered = dashboards.filter(item =>
      dashboardAccess.includes(`~${item.value}~`)
    );

    this.options = [...this.options, ...filtered];
    dashboard = systemDashboard[0];
    const today = new Date();
    const startOfDay = `${today.getFullYear()}-${String(
      today.getMonth() + 1
    ).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')} 00:00:00`;
    const endOfDay = `${today.getFullYear()}-${String(
      today.getMonth() + 1
    ).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')} 23:59:59`;
    this.state = { dashboard, salespersons, selectedSalesperson, startDate: startOfDay, endDate: endOfDay, refreshKey: Date.now(), };
  }

  onChange = dashboard => { this.setState({ ...this.state, dashboard }); };

  onSalespersonChange = selectedSalesperson => this.setState({ selectedSalesperson });

  // handleDateChange = (start, end) => {
  //   let startDate = '',
  //     endDate = '';
  //   if (typeof start === 'string' && typeof end === 'undefined') {
  //     const dateRangeStr = start;
  //     if (dateRangeStr.includes('~')) {
  //       const [rawStart, rawEnd] = dateRangeStr.split('~').map(s => s.trim());
  //       startDate = rawStart.includes(':') ? rawStart : `${rawStart} 00:00:00`;
  //       endDate = rawEnd.includes(':') ? rawEnd : `${rawEnd} 23:59:59`;
  //     } else {
  //       startDate = dateRangeStr.includes(':') ? dateRangeStr : `${dateRangeStr} 00:00:00`;
  //       endDate = dateRangeStr.includes(':') ? dateRangeStr : `${dateRangeStr} 23:59:59`;
  //     }
  //   } else if (typeof start === 'string' && typeof end === 'string') {
  //     startDate = start.includes(':') ? start : `${start} 00:00:00`;
  //     endDate = end.includes(':') ? end : `${end} 23:59:59`;
  //   }

  //   const refreshKey = Date.now();
  //   this.setState({ startDate, endDate, refreshKey }, () => {
  //     console.log(`Date Selected: ${startDate} ~ ${endDate}`);
  //   });
  // };

  loadWidgets = () => {
    const { dashboard } = this.state;
    if (!dashboard) return null;
    if (dashboard.type === 'system') {
      return (
        <MyDashboard
          models={this.models}
          responsibleId={this.state.selectedSalesperson?.value}
          refreshKey={this.state.refreshKey}
        />
      );
    }

    if (dashboard.type === 1) {
      const filters = JSON.parse(dashboard.filters || '[]');
      let reports = dashboard.reports;
      reports = reports.substring(1, reports.length - 1).split(Const.Opt);
      return reports.map((id, i) => {
        const filter = filters?.find(item => parseInt(item.report) === parseInt(id));
        return <DashboardItem key={`dashboard_${i}`} id={id} filters={filter} />;
      });
    } else if (
      dashboard.type === 2 &&
      dashboard.dashleads &&
      dashboard.dashleads.length > 2
    ) {
      let dashleads = dashboard.dashleads;
      dashleads = dashleads.substring(1, dashleads.length - 1).split(Const.Opt);
      return dashleads.map((id, i) => (
        <Widget key={`dash_${i}`} id={id} models={this.models} dashbaord={true} />
      ));
    }

    return null;
  };

  render() {
    const widgets = this.loadWidgets();
    const { selectedSalesperson, salespersons, dashboard } = this.state;
    const userName =
      reactLocalStorage.getObject(Const.LoggedInUser)?.staff_name || 'User';
    const isSystemDashboard = dashboard?.type === 'system';

    return (
      <>
        <div className="container-fluid mt-1 bg-color">
          <div className="row align-items-center mb-2">
            {isSystemDashboard ? (
              <>
                <div className="col-md-8">
                  <h3 className="text-dark mb-0">
                    Welcome, <span className="fw-bold" style={{fontWeight: '700'}}>{userName}</span>
                  </h3>
                </div>
                {/* This line is commented because for now we dont need filter if client want we will check */}
                {/* <div className="col-md-5">
                  <div className='pt-3'>
                    <CustomDatePicker onDateChange={this.handleDateChange} isLabel={true} />
                  </div>
                </div> */}
                <div className="col-md-2">
                  {salespersons.length > 0 ? (
                    <Select value={selectedSalesperson} onChange={this.onSalespersonChange} options={salespersons} placeholder="Select Salesperson" className="w-100" />
                  ) : (
                    <div className="text-danger">No salespersons available</div>
                  )}
                </div>
                <div className="col-md-2">
                  <Select value={dashboard} onChange={this.onChange} options={this.options} className="w-100" />
                </div>
              </>
            ) : (
              <div className="col-md-12 d-flex justify-content-end">
                <div style={{ width: '250px' }}>
                  <Select value={dashboard} onChange={this.onChange} options={this.options} className="w-100" />
                </div>
              </div>
            )}
          </div>
          <div className="row">{widgets}</div>
        </div>
      </>
    );
  }
}

export default Dashboard;
